/**
 * Free-text genre → the closest of Cover Studio's 5 STYLE directions (not a genre group —
 * this page shows design treatments: Minimalist Literary, Bold Commercial, Warm & Human,
 * Atmospheric, Type-Forward). Same keyword-match + honest-fallback shape as
 * resolve-genre.js (cover-showcase) and the real backend's resolveGenre().
 */
const STYLE_KEYWORDS = [
  ['Bold Commercial', /thriller|suspense|crime|mystery|detective|spy|action|heist|noir/i, 'high commercial-score genres (thriller/mystery)'],
  ['Warm & Human', /romance|memoir|biography|personal essay|true story|heartfelt|coming[- ]of[- ]age/i, 'character-driven genres (romance/memoir)'],
  ['Atmospheric', /fantasy|sci[- ]?fi|science fiction|horror|dystopia|epic|space opera|magic|dragon|ya|young adult/i, 'mood-driven genres (fantasy/sci-fi/horror)'],
  ['Type-Forward', /business|self[- ]?help|nonfiction|leadership|finance|entrepreneur|how[- ]?to|productivity/i, 'nonfiction/business'],
  ['Minimalist Literary', /literary|poetry|poem|contemporary|drama|quiet|essay/i, 'literary fiction'],
];

/**
 * @param {string} input free-text genre
 * @param {{name:string}[]} directions the local `directions` array
 * @returns {{ index: number, name: string, matched: boolean, reason: string }}
 */
export function resolveGenreToStyleIndex(input, directions) {
  const text = (input || '').trim();
  if (text) {
    for (const [name, re, reason] of STYLE_KEYWORDS) {
      if (re.test(text)) {
        const index = directions.findIndex((d) => d.name === name);
        if (index !== -1) return { index, name, matched: true, reason };
      }
    }
  }
  const fallbackIndex = directions.findIndex((d) => d.name === 'Minimalist Literary');
  return { index: fallbackIndex === -1 ? 0 : fallbackIndex, name: 'Minimalist Literary', matched: false, reason: 'no keyword match — literary is the platform default' };
}
